module.exports = __webpack_public_path__ + "static/media/curves_ambar.1f49d9c6.jpg";